import {getBaseUrl} from '../../utils';
import io from '../../lib/io'


export async function getAdminSections() {
  return await io.get(`${getBaseUrl()}/admin/utils/sections`);
}